import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { BreadcrumbProvider } from '@repo/components/contexts';
import { ThemeProvider } from '@mui/material/styles';
import { loadComponents } from '@nineeng/form-components';
import { registry } from '@nineeng/forms';
import { MultiEmailInput, CustomFormComponent, MultiFreeInput } from '@repo/components';
import { muiExitTheme } from '@repo/theme';
if (typeof window !== 'undefined') {
	loadComponents(registry);
	registry.addField('Custom', CustomFormComponent);
	registry.addField('MultiFreeInput', MultiFreeInput);
	registry.addField('MultiEmailInput', MultiEmailInput);
	// registry.addField('LanguageSelect', LanguageSelect);
}

export const Route = createRootRoute({
	component: () => (
		<ThemeProvider theme={muiExitTheme}>
			<BreadcrumbProvider>
				<Outlet />
				<TanStackRouterDevtools />
			</BreadcrumbProvider>
		</ThemeProvider>
	),
});
